import types from './types'

export const connect = (token) => ({ type: types.CONNECT, token })
export const authenticate = (token, systemName, accountId) => ({ type: types.WS_AUTHENTICATE, token, systemName, accountId })
export const connected = () => ({ type: types.CONNECTED })
export const disconnect = () => ({ type: types.DISCONNECT })
export const disconnected = (userDisconnected, closeEvent, tries) => ({ type: types.DISCONNECTED, userDisconnected, closeEvent, tries })

export const ping = () => ({ type: types.PING })

export const observe = (systemName, accountId, dataType, objectId) => ({ type: types.OBSERVE, systemName, accountId, dataType, objectId })
export const deobserve = (systemName, accountId, dataType, objectId) => ({ type: types.DEOBSERVE, systemName, accountId, dataType, objectId })

export const observeQuote = (ref) => ({ type: types.OBSERVE_QUOTE, ref })
export const deobserveQuote = (ref) => ({ type: types.DEOBSERVE_QUOTE, ref })

export const observeInvoice = (id) => ({ type: types.OBSERVE_INVOICE, id })
export const deobserveInvoice = (id) => ({ type: types.DEOBSERVE_INVOICE, id })

export const observePart = (id) => ({ type: types.OBSERVE_PART, id })
export const deObservePart = (id) => ({ type: types.DEOBSERVE_PART, id})

export const observeJobCards = () => ({ type: types.OBSERVE_JOB_CARDS })
export const deObserveJobCards = () => ({ type: types.DEOBSERVE_JOB_CARDS })

export const observePurchaseOrder = (id) => ({ type: types.OBSERVE_PURCHASE_ORDER, id })
export const deObservePurchaseOrder = (id) => ({ type: types.DEOBSERVE_PURCHASE_ORDER, id })

export const observerPurchaseInvoice = (id) => ({ type: types.OBSERVE_PURCHASE_INVOICE, id })
export const deObservePurchaseInvoice = (id) => ({ type: types.DEOBSERVE_PURCHASE_INVOICE, id })

export const observeOpportunities = () => ({ type: types.OBSERVE_OPPORTUNITIES })
export const deObserveOpportunities = () => ({ type: types.DEOBSERVE_OPPORTUNITIES })

export const observeCompanies = () => ({ type: types.OBSERVE_COMPANIES })
export const deObserveCompanies = () => ({ type: types.DEOBSERVE_COMPANIES })

export const observeContacts = () => ({ type: types.OBSERVE_CONTACTS })
export const deObserveContacts = () => ({ type: types.DEOBSERVE_CONTACTS })

export const observeDeliveries = () => ({ type: types.OBSERVE_DELIVERY })
export const deObserveDeliveries = () => ({ type: types.DEOBSERVE_DELIVERY })
